<div class="eap-container">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-eap-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.page-title.eap" | translate }}
            {{ " " + (index + 1) }}
        </div>
        <div class="location-container">
            <mat-icon svgIcon="location_on"> </mat-icon>
            {{ eap.location }}
        </div>
    </div>
    <div class="status-container">
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(eap.run) === 'status-error',
            }"
        >
            {{ "system-status.eap.run" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-eap-run-icon"
                svgIcon="{{ getIcon(eap.run) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(eap.initialized) === 'status-error',
            }"
        >
            {{ "system-status.eap.initialized" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-eap-init-icon"
                svgIcon="{{ getIcon(eap.initialized) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
    </div>
</div>
